var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:(_vm.loadingVisibilityChanged),expression:"loadingVisibilityChanged"}],style:({ minHeight: '60px' })},[(_vm.visible)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }